import SkipLinks from './SkipLinks.component';

export default SkipLinks;
